<template>
    <div>
        <div>
            <img src="../assets/banner/核心业务banner1920x280px.png">
        </div>
        <div class="margin-auto margin-top-30 flex" style="width:1200px;">
            <div class="leftMenu">
                <detailNav ref="nav"  :list="nav.hexinyewu" @change="handleChange"/>
            </div>
            <div class="rightConent">
                <div class="margin-bottom-30">
                    <tab :title="info.title"/>
                </div>
                <div class="img" v-if="info.artImg">
                    <img :src="info.artImg" alt=""  class="img-100">
                    <!-- <div class="title-img">{{info.title}}</div> -->
                </div>
                <div style="margin-top:30px;" class="flex introduce">
                    <div v-html="info.content">

                    </div>
      
                </div>
                <div v-if="xiang" style="margin-top:30px;width: 880px;">
                    <tabs title="相关案例"/>
                    
                    <notable/>
                    
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import detailNav from '../components/detailNav'
    import notable from '../components/coreBusiness/notable'
    import tabs from '../components/coreBusiness/tabs'
    import {mapGetters,mapMutations} from 'vuex'
    import {getKernel} from '../api/api'
    import tab from '../components/tab'
    export default {
        name: 'CaseDetail',
        components:{
            tabs,
            detailNav,
            notable,
            tab
        },
        computed:{
            ...mapGetters({
                nav:'getNav'
            })
        },
        data() {
            return {
                info:{},
                index:0,
                xiang:true
            }
        },
        methods:{
            getData(id){
                getKernel({typeid:id}).then(res=>{
                    //console.log(res)
                    if(res.code==1){
                        
                        this.info=res.data
                    }
                })
            },
            handleChange(index){
                // this.info=this.list[index]
                this.$router.push({path:'/CoreBusiness',query:{index:index}})
            }
        },
        mounted(){
           
            if(this.$route.query.xiang!==undefined){
                this.xiang=false;
            }
            this.index=this.$route.query.index
            // console.log(this.index)
            this.$refs.nav.setActive(this.index)
            this.getData(this.$route.query.id)
        }
    }
</script>

<style lang="scss" scoped>
    .rightConent{
        margin-left: 100px;
        width: 900px;
    }
    .leftMenu{
        width: 220px;
    }
    
    .img{
        background: #CDB499;
        width: 100%;
        height: 454px;
        position: relative;
    }
    .img .title-img{
        position:absolute;
        bottom: 0;
        right: 0;
        color: #fff;
        padding: 10px;
  
        background:rgba(40,40,40,.6);
   
    }
  
    .introduce .img1+div{
        margin:30px 0 10px 0;
        color: #27499d;
    }
    .bg-color{
        background: #f8f8f8;
    }
</style>